//@ts-nocheck
import React, { act, useCallback, useEffect, useState } from "react";
import styles from "./Requirement.module.scss";
import MadLib from "./MadLib/MadLib";
import TextInputList from "./TextInputList/TextInputList";
import { TextFieldWrapper } from "@factorearth/component-library";
import { components } from "react-select";
import { DropdownSelect } from "@factorearth/component-library";

function Requirement(props) {
	const { color, index, templateData, optionData, actionElement, value, handleSubmit } = props;

	const [newValue, setNewValue] = useState(value || "");
	const [optionMap, setOptionMap] = useState<OptionMapValues>(setupOptionsMap(optionData));
	const delim = String.fromCharCode(31);

	// this is like this so things operate in a very similar fashion to the other dropdowns.
	useEffect(() => {
		setOptionMap(setupOptionsMap(optionData));
	}, [optionData]);

	useEffect(() => {
		if (value !== newValue) {
			setNewValue(value);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [value]);

	const handleChange = useCallback((e) => {
		const changedValue = e.target.value;
		setNewValue(changedValue);
	}, []);

	function setupOptionsMap(options: Option[]): OptionMapValues {
		let map = {};
		for (let i = 0; i < optionData.length; i++) {
			const option = optionData[i];
			let id = option.id;
			map[id] = option;
		}
		return map;
	}

	/**
	 * Setup html for the different requirements.
	 * @returns final html for the requirement input.
	 */
	function renderRequirement() {
		let final;
		switch (actionElement.requirements) {
			case "TEXT_INPUT":
				final = renderText();
				break;
			case "DATA_LIST":
				final = renderDataList();
				break;
			case "OPTION_IDS":
				final = renderOptionList();
				break;
			case "OPTION_DOCID":
				final = renderOptionListForDocId();
				break;
			case "TEXT_INPUT_LIST":
				final = renderTextInputList();
				break;
			case "FIELD_DOCID":
				final = renderFieldList();
				break;
			case "FIELD_ID":
				final = renderFieldList();
				break;
			case "MADLIB_TABLEFIELDS_ID":
				final = renderMadLibs();
				break;
			default:
				break;
		}
		return final;
	}

	/**
	 * Pretty much going to setup a dynamic madlibs situation to use a boiler plate text and insert
	 * field data into it.  Users will be able to build out a string and insert field templates.
	 * Their values will be placed in the position they are placed in the string on export.
	 */
	function renderMadLibs() {
		const optionData = [];
		// OPTION DATA IS JUST HARDCODED TO STUPID LIST FOR NOW, WILL NEED TO PASS IN THE APPROPRATE THING
		// Setup the optionData to be a field template header and id obj list off the templateData.tableFields.items
		for (let i = 0; i < templateData.tableFields.items.length; i++) {
			const field = templateData.tableFields.items[i];
			optionData.push({
				header: field.header,
				id: field.id,
			});
		}
		optionData.push({
			header: "NONE",
			id: "NONE",
		});

		return <MadLib actionElement={actionElement} index={index} color={color} value={value} handleSubmit={handleSubmit} optionData={optionData} />;
	}

	/**
	 * dynamic list of text inputs, to allow inifnite number of things.
	 * This will allow users to edit a text input and add it to the list.  Then it will be parsed based on
	 * the actionElements target.
	 */
	function renderTextInputList() {
		return <TextInputList actionElement={actionElement} handleBlur={handleBlur} handleChange={handleChange} value={newValue} colorPalette={color} />;
	}

	/**
	 * Dropdown field on change handler
	 * @param {{label: string, value: string}[] | {label: string, value: string}} e event data
	 */
	function handleChangeSelectFieldList(e) {
		// parse value change to string for handleChange submission
		let valueString = "";
		if (Array.isArray(e)) {
			for (let i = 0; i < e.length; i++) {
				const selectedOption = e[i];
				valueString += i === e.length - 1 ? selectedOption.id : `${selectedOption.id}${delim}`;
			}
		} else {
			valueString = e.id;
		}

		const data = {
			target: {
				value: valueString,
			},
		};

		setNewValue(valueString);
		handleSubmit(valueString, index);
	}

	/**
	 * Dropdown field on change handler
	 * @param {{label: string, value: string}[] | {label: string, value: string}} e event data
	 */
	function handleChangeSelectFieldListUsingDocId(e) {
		// parse value change to string for handleChange submission
		let valueString = "";
		console.log("Eevent: ", e);
		if (Array.isArray(e)) {
			for (let i = 0; i < e.length; i++) {
				const selectedOption = e[i];
				valueString += i === e.length - 1 ? selectedOption.docId : `${selectedOption.docId}${delim}`;
			}
		} else {
			valueString = e.docId;
		}

		const data = {
			target: {
				value: valueString,
			},
		};

		setNewValue(valueString);
		handleSubmit(valueString, index);
	}

	/**
	 * Dropdown field on change handler
	 * @param {{label: string, value: string}[] | {label: string, value: string}} e event data
	 */
	function handleChangeSelect(e) {
		// parse value change to string for handleChange submission
		let valueString = e.target.value;

		const data = {
			target: {
				value: valueString,
			},
		};

		setNewValue(valueString);
		handleSubmit(valueString, index);
	}

	/**
	 * setup a dropdown with the field template options for docid and id requirements.
	 * This is expecting the optionData to have FieldTemplates.
	 */
	function renderFieldList() {
		const options = [];
		for (let i = 0; i < optionData.length; i++) {
			const option = optionData[i];
			const html = (
				<option id={option.id} value={option.id}>
					{option.header}
				</option>
			);
			options.push(html);
		}

		// options.push(
		// 	<option id={"NONE"} value={""}>
		// 		None
		// 	</option>
		// );

		const final = (
			<select onChange={handleChangeSelectFieldList} value={newValue}>
				{options}
			</select>
		);
		return final;
	}

	const CustomOption = (props) => {
		return (
			<span id={`${props.selectProps["classNamePrefix"]}-option-${props.data.id}`} key={props.innerProps.key}>
				<components.Option {...props} />
			</span>
		);
	};

	const CustomMultiValueContainer = (props) => {
		return (
			<span id={`${props.selectProps["classNamePrefix"]}-multi-value-${props.data.id}`}>
				<components.MultiValueContainer {...props} />
			</span>
		);
	};

	function buildOptions() {
		let map = {};
		let options = [];
		// Build out the fieldInstance .field template options
		for (let i = 0; i < optionData.length; i++) {
			const option = optionData[i];
			let id = option.id;

			const optionItemData = {
				...option,
				label: option.label,
				value: option.label,
				id,
			};

			// this map is for the ordering so must use the main id
			map[option.id] = optionItemData;
		}

		const optionOrdering = templateData.optionsOrder ?? optionData.map((option) => option.id);

		// do the optionsorder
		for (let i = 0; i < optionOrdering.length; i++) {
			const optionId = optionOrdering[i];
			const optionData = map[optionId];
			options.push(optionData);
		}

		return options;
	}

	/**
	 * setup the selected string value into objects for the dropdown
	 * @returns selected values as dropdown option objects
	 */
	function buildValue() {
		if (!newValue || newValue === "") {
			return [];
		}
		const idArray = newValue.split(delim);
		let values = [];

		for (let i = 0; i < idArray.length; i++) {
			const id = idArray[i];
			if (id === "") {
				continue;
			}
			const option = optionMap[id];
			let valueObj = {};
			if (!option) {
				valueObj = {
					id,
					value: id,
					label: id,
				};
				// continue;
			} else {
				valueObj = {
					id,
					value: option.label,
					label: option.label,
				};
			}

			values.push(valueObj);
		}

		return values;
	}

	/**
	 * setup a dropdown with options to select.  This will work for docId, or Id
	 */
	function renderOptionList() {
		// const options = [];

		const final = (
			<DropdownSelect
				name="Requirements: "
				id={templateData.id}
				isMulti={true} // single select ones will need to be handled here when we need them.
				value={buildValue()}
				onChange={handleChangeSelectFieldList}
				options={buildOptions()}
				isSearchable={true}
				menuPlacement="auto"
				minMenuHeight={300}
				menuPortalTarget={document.body}
				colorPalette={color}
				classNamePrefix={templateData.id}
				components={{
					Option: (props) => <CustomOption {...props} />,
					MultiValueContainer: (props) => <CustomMultiValueContainer {...props} />,
				}}
			/>
		);

		return final;
	}

	/**
	 * setup a dropdown with options to select.  This will work for docId, or Id
	 */
	function renderOptionListForDocId() {
		// const options = [];

		const final = (
			<DropdownSelect
				name="Requirements: "
				id={templateData.id}
				isMulti={true} // single select ones will need to be handled here when we need them.
				value={buildValue()}
				onChange={handleChangeSelectFieldListUsingDocId}
				options={buildOptions()}
				isSearchable={true}
				menuPlacement="auto"
				minMenuHeight={300}
				menuPortalTarget={document.body}
				colorPalette={color}
				classNamePrefix={templateData.id}
				components={{
					Option: (props) => <CustomOption {...props} />,
					MultiValueContainer: (props) => <CustomMultiValueContainer {...props} />,
				}}
			/>
		);

		return final;
	}

	/**
	 * Setup a dropdown selector for a list of possible values from the data property on the action element.
	 */
	function renderDataList() {
		const options = [];
		for (let i = 0; i < actionElement.data.length; i++) {
			const option = actionElement.data[i];
			const html = (
				<option id={option} value={option}>
					{option}
				</option>
			);
			options.push(html);
		}

		const final = (
			<select onChange={handleChangeSelect} value={newValue}>
				{options}
			</select>
		);
		return final;
	}

	/**
	 * blur handler
	 */
	function handleBlur() {
		handleSubmit(newValue, index);
	}

	/**
	 * setup a text field for the action element requirement.
	 */
	function renderText() {
		if (templateData?.inputType === "note") {
			return (
				<textarea
					className={styles.textInput}
					value={newValue}
					onChange={handleChange}
					onBlur={handleBlur}
					rows={5}
					style={{ width: "100%", fontFamily: "inherit", padding: "8px", resize: "vertical", boxSizing: "border-box" }}
				/>
			);
		}
		const html = (
			<TextFieldWrapper
				type={templateData?.action[0] === "CHARACTER_LIMIT" ? "number" : "text"}
				className={styles.textInput}
				value={newValue}
				onChange={handleChange}
				onBlur={handleBlur}
				colorPalette={color}
			/>
		);
		return html;
	}

	return <div data-test={`requirement-at-index-${index}`}>{renderRequirement()}</div>;
}

export default Requirement;
